import { Component, OnInit, Input, TemplateRef } from '@angular/core';
import { FormGroup, FormControl, Validators, DefaultValueAccessor } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { CommonService } from '../shared/providers/common.service';
import { IStatesList } from '../shared/models/StatesListOutputModel';
import { ICities } from '../shared/models/CitiesListOutputModel';
import { ITrade1031InputModel, ILookUpList } from '../shared/models/Trade1031InputModel';
import { spaceOnlyValidator } from '../shared/providers/validation.service';
import { EmailValidator } from '../shared/providers/validation.service';
import { DateValidator } from '../shared/providers/validation.service';
import { AuthenticationService } from '../shared/auth/authentication.service'
import { UserManagerService } from '../shared/providers/user-manager.service';
import { ILookUp } from '../shared/models/LookUpOutputModel';
import { ValidationService } from '../shared/providers/validation.service';
import { ToastService } from '../shared/providers/toast.service';
import { Trade1031Service } from '../shared/providers/Trade1031.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { LoaderService } from '../shared/providers/loader.service';

enum ActiveTab {
  TraderInfo = 1,
  TraderPreference = 2,
  ReviewAndSubmit = 3,
}

enum LookUpsType {
  AssetTypes = 2,
  Strategies = 20,
  Geography = 21
}

enum Actions {
  Save = 1,
  Update = 2
}

@Component({
  selector: 'reg-1031',
  templateUrl: './1031-registration.component.html',

})
export class User1031RegistrationComponent implements OnInit {
  action = Actions.Save;
  isGuestUser = false;
  isNewEntry = false;
  constructor(private activatedRoute: ActivatedRoute, private _commonService: CommonService, public authService: AuthenticationService, private modalService: BsModalService,
    private _userManagerService: UserManagerService, public _validationService: ValidationService, private Toast: ToastService,
    private _Trade1031Service: Trade1031Service, private router: Router, private Loader: LoaderService) {

    this.activatedRoute.params.subscribe(params => {
      if (params.id === undefined || params.id === null) {
        this.action = Actions.Save;
        this.trade1031InputModel.ExchangeGuid = null;
      }
      else {
        this.action = Actions.Update;
        let exGuid: string = params.id;
        this.trade1031InputModel.ExchangeGuid = exGuid.split('?')[0];
      }
    });
  }
  modalRef: BsModalRef;
  activeTab: number = ActiveTab.TraderInfo;
  traderInfoDone = false;
  statesList: IStatesList[];
  trade1031InputModel = {} as ITrade1031InputModel;
  traderInfoForm: FormGroup;
  traderCriteria: FormGroup;
  istraderInfoSubmitted = false;
  citiesList: ICities[];
  assetType: ILookUpList[];
  geography: ILookUpList[];
  strategies: ILookUp[];
  selectedState = '';
  selectedCity = '';
  strategyModel = 0;
  userRole = "";
  loggedUserDetails: any;
  BC_routeName = '';
  BC_routeLink = '';
  routecompaignPage: boolean = false;
  ipAddress: string;
  parentId = 0;
  user: any;
  ngOnInit() {
    this.user = this.authService.user;
    this._validationService.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });

    this.showSuccessDiv = false;
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      let routeName = params['prevroute'];
      let routeLink = params['link'];
      let routecompaignPage = params['compaignPage'];
      if (this._validationService.IsValid(params['parentId'])) {
        this.parentId = params['parentId'];
      }

      
      if (routeName !== null && routeLink !== null && routeName !== undefined && routeLink !== undefined) {
        this.BC_routeName = routeName;
        if (this.parentId == 100) {
          this.BC_routeLink = routeLink;
        }
        else {
          this.BC_routeLink = routeLink;
        }
      }
      else {
        this.BC_routeName = '1031 Trade';
        this.BC_routeLink = "1031-trade";
      }
      if (routecompaignPage !== null && routecompaignPage !== undefined) {
        if (routecompaignPage == 'true') {
          this.routecompaignPage = true;
        }
      }

      if (params['user'] !== null && params['user'] !== undefined) {
        this.isGuestUser = true;
      }
      if (params['type'] !== null && params['type'] !== undefined) {
        if (params['type'] === "new") {
          this.isNewEntry = true;
        }
      }
    });

    this.authService.isLoggedIn.subscribe(response => {
      if (response) {
        this.loggedUserDetails = this.authService.user;

      }
      //else if (!this.isGuestUser) {
      //    this.router.navigate(['/trade-1031']);
      //}
    });

    this._commonService.getLookupsByTypeId(LookUpsType.Strategies).subscribe(response => {
      this.strategies = response.map(o => { return { id: o.Id, description: o.Description, }; });
    });

    this._commonService.getStateList().subscribe(response => {
      this.statesList = response.map(o => { return { Id: o.Id, Name: o.StateName }; });
    });


    if (this.action == Actions.Save) { //Save inquiry

      this._commonService.getTypeList().subscribe(response => {
        this.assetType = response.map(o => {
          return { id: o.Id, description: o.Type, selected: false };
        });
      });
      this._commonService.getLookupsByTypeId(LookUpsType.Geography).subscribe(response => {
        this.geography = response.map(o => { return { id: o.Id, description: o.Description, selected: false }; });
      });

      this.setUserDetails(this.loggedUserDetails.Guid);
      this.trade1031InputModel.state = 0;
      this.trade1031InputModel.city = 0;
      this.trade1031InputModel.capratemin = null;
      this.trade1031InputModel.capratemax = null;
      this.trade1031InputModel.rentmin = null;
      this.trade1031InputModel.rentmax = null;
      this.trade1031InputModel.exchangestateid = 0;
    }
    else { //Edit inquiry
      this.Loader.display(true);

      this._commonService.getTypeList().subscribe(response => {
        this.assetType = response.map(o => { return { id: o.Id, description: o.Type, selected: false }; });

        this._commonService.getLookupsByTypeId(LookUpsType.Geography).subscribe(response => {
          this.geography = response.map(o => { return { id: o.Id, description: o.Description, selected: false }; });

          this._Trade1031Service.Get1031ExchangeDetailsForEdit(this.trade1031InputModel.ExchangeGuid).subscribe(res => {
            this.setUserDetails(res["Guid"]);
            this.trade1031InputModel.sold_projectedsaledate = res["Sold_ProjectedSaleDate"] ? this._validationService.convertUTCDateToLocalDate(res["Sold_ProjectedSaleDate"]) : null;
            this.trade1031InputModel.totalsaleprice = res["TotalSalePrice"];
            this.trade1031InputModel.totalequity = res["TotalEquity"];
            this.trade1031InputModel.totaldebt = res["TotalDebt"];
            this.trade1031InputModel.address = res["Address"];
            this.trade1031InputModel.address = res["Address"];
            this.trade1031InputModel.state = res["State"];
            this.selectedState = res["StateName"];
            this._commonService.getCitiesList(this.trade1031InputModel.state).subscribe(response => {
              this.citiesList = response.map(o => { return { Id: o.Id, Name: o.CityName }; });
            });
            this.trade1031InputModel.city = res["City"];
            this.selectedCity = res["CityName"];

            this.trade1031InputModel.strategyid = res["StrategyId"];
            this.strategyModel = res["StrategyId"];
            this.trade1031InputModel.strategyText = res["StrategyText"];
            this.strategyText = this.trade1031InputModel.strategyText;
            this.selectedPropertyType = res["PropertyTypes"];
            this.selectedGeography = res["GeographyTypes"];
            this.trade1031InputModel.capratemin = res["CapRateMin"];
            this.trade1031InputModel.capratemax = res["CapRateMax"];
            this.trade1031InputModel.rentmin = res["RentMin"];
            this.trade1031InputModel.rentmax = res["RentMax"];
            this.trade1031InputModel.exchangestateid = res["ExchangeStateId"];
            this.selectedExchangeLocation = res["ExchangeStateName"];
            this.trade1031InputModel.specificpreferences = res["SpecificPreferences"];

            let Propcount = 0;
            let PropertyType = [] = res["PropertyType"];
            if (this.assetType) {
              PropertyType.forEach(item => {
                let found = this.assetType.find(x => x.id === item.Id);
                if (found) {
                  Propcount++;
                  found.selected = true;
                }
              });
            }

            if (Propcount == (this.assetType ? this.assetType.length : 0)) {
              this.selectAllAssetTypeValue = true;
            }
            else {
              this.selectAllAssetTypeValue = false;
            }

            let Geographycount = 0;
            let GeographyType = [] = res["GeographyType"];
            if (this.geography) {
              GeographyType.forEach(item => {
                let found = this.geography.find(x => x.id === item.Id);
                if (found) {
                  Geographycount++;
                  found.selected = true;
                }
              });
            }

            if (Geographycount == (this.geography ? this.geography.length : 0)) {
              this.selectAllgeographyValue = true;
            }
            else {
              this.selectAllgeographyValue = false;
            }
            this.Loader.display(false);
          });
        });
      });
    }

    this.traderInfoForm = new FormGroup({
      'txtfirstname': new FormControl(this.trade1031InputModel.firstname, [
        Validators.required,
        Validators.minLength(2),
      ]),
      'txtlastname': new FormControl(this.trade1031InputModel.lastname, [
      ]),
      'txtemail': new FormControl(this.trade1031InputModel.email, [
        Validators.required,
        EmailValidator
      ]),
      'txtphone': new FormControl(this.trade1031InputModel.phone, [
        //Validators.required,
        Validators.minLength(10),
      ]),
      'txtsold_projectedsaledate': new FormControl(this.trade1031InputModel.sold_projectedsaledate, [
        Validators.required,
        DateValidator
      ]),
      'txttotalsaleprice': new FormControl(this.trade1031InputModel.totalsaleprice, [
        Validators.required,
        Validators.min(1),
      ]),
      'txttotalequity': new FormControl(this.trade1031InputModel.totalequity, [
        //Validators.required,
      ]),
      'txttotaldebt': new FormControl(this.trade1031InputModel.totaldebt, [
        //Validators.required,
      ]),
      'txtaddress': new FormControl(this.trade1031InputModel.address, [
      ]),
      'txtstate': new FormControl(this.trade1031InputModel.state, [
      ]),
      'txtcity': new FormControl(this.trade1031InputModel.city, [
      ]),
    })

    this.traderCriteria = new FormGroup({

      'txtRentMin': new FormControl(this.trade1031InputModel.totalequity, [
      ]),
      'txtRentMax': new FormControl(this.trade1031InputModel.totaldebt, [
      ]),
    })
  }

  get txtfirstname() { return this.traderInfoForm.get('txtfirstname'); }
  get txtlastname() { return this.traderInfoForm.get('txtlastname'); }
  get txtemail() { return this.traderInfoForm.get('txtemail'); }
  get txtphone() { return this.traderInfoForm.get('txtphone'); }
  get txtsold_projectedsaledate() { return this.traderInfoForm.get('txtsold_projectedsaledate'); }
  get txttotalsaleprice() { return this.traderInfoForm.get('txttotalsaleprice'); }
  get txttotalequity() { return this.traderInfoForm.get('txttotalequity'); }
  get txttotaldebt() { return this.traderInfoForm.get('txttotaldebt'); }
  get txtaddress() { return this.traderInfoForm.get('txtaddress'); }
  get txtstate() { return this.traderInfoForm.get('txtstate'); }
  get txtcity() { return this.traderInfoForm.get('txtcity'); }

  get txtRentMin() { return this.traderCriteria.get('txtRentMin'); }
  get txtRentMax() { return this.traderCriteria.get('txtRentMax'); }

  setUserDetails(userGuid) {
    this._userManagerService.getUserDetails(userGuid).subscribe(response => {
      this.trade1031InputModel.firstname = response.FirstName;
      this.trade1031InputModel.lastname = response.LastName;
      this.trade1031InputModel.email = response.Email;
      this.trade1031InputModel.phone = response.Phoneno;
      this.trade1031InputModel.userid = response.Id;
    });
  }

  ProceedTraderInfo() {
    this.istraderInfoSubmitted = true;
    if (!this.traderInfoForm.invalid) {
      this.activeTab = ActiveTab.TraderPreference;
      this.traderInfoDone = true;
      this._Trade1031Service.Save1031TradeToUserFlowLog(this.trade1031InputModel).subscribe(response => {

      })

    }
  }

  ProceedTradePreference() {
    if (this.IsTradePreferenceValid()) {
      this.activeTab = ActiveTab.ReviewAndSubmit;
      this._Trade1031Service.Save1031TradeToUserFlowLog(this.trade1031InputModel).subscribe(response => {

      })
    }
  }
  onKeydown(event, tab) {

    if (event.key === "Enter" && tab == 'tab1') {
      this.ProceedTraderInfo();
    }
    if (event.key === "Enter" && tab == 'tab2') {
      this.ProceedTradePreference();
    }
  }



  IsTradePreferenceValid() {
    this.validateDecimals();
    if (Number(this._validationService.IsNullThen(this.trade1031InputModel.capratemin, 0)) > 100) {
      this.Toast.addToast({ title: 'Error Occurred', msg: 'Minimum Cap Rate should not be greater than 100', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
    }
    else if (Number(this._validationService.IsNullThen(this.trade1031InputModel.capratemax, 0)) > 100) {
      this.Toast.addToast({ title: 'Error Occurred', msg: 'Maximum Cap Rate should not be greater than 100', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
    }
    else if ((Number(this._validationService.IsNullThen(this.trade1031InputModel.capratemax, 0)) > 0) && (Number(this._validationService.IsNullThen(this.trade1031InputModel.capratemin, 0)) > Number(this._validationService.IsNullThen(this.trade1031InputModel.capratemax, 0)))) {

      this.Toast.addToast({ title: 'Error Occurred', msg: 'Minimum Cap Rate should not be greater than Maximum Cap Rate', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
    }
    else if ((Number(this._validationService.IsNullThen(this.trade1031InputModel.rentmax, 0)) > 0) && (Number(this._validationService.IsNullThen(this.trade1031InputModel.rentmin, 0)) > Number(this._validationService.IsNullThen(this.trade1031InputModel.rentmax, 0)))) {
      this.Toast.addToast({ title: 'Error Occurred', msg: 'Expected Minimum Rent/NOI  should not be greater than Expected Maximum Rent/NOI', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
    }
    else {
      return true;
    }
    return false;
  }

  previous(tab) {
    this.tabChange(tab);
  }

  tabClick(tab) {
    this.istraderInfoSubmitted = true;
    if (tab == ActiveTab.TraderInfo) {
      this.activeTab = ActiveTab.TraderInfo;
    }
    else if (tab == ActiveTab.TraderPreference) {
      if (this.traderInfoForm.invalid) {
        this.activeTab = ActiveTab.TraderInfo;
      }
      else {
        this.activeTab = ActiveTab.TraderPreference;
      }
    }
    else if (tab == ActiveTab.ReviewAndSubmit) {
      if (this.traderInfoForm.invalid) {
        this.activeTab = ActiveTab.TraderInfo;
      }
      else if (!this.IsTradePreferenceValid()) {
        this.activeTab = ActiveTab.TraderPreference;
      }
      else {
        this.activeTab = ActiveTab.ReviewAndSubmit;
      }
    }

  }

  onHomeBreadCrumbClick() {
    this.router.navigateByUrl('/principal-dashboard');
  }

  tabChange(tab) {
    if (tab == ActiveTab.TraderInfo) {
      this.activeTab = ActiveTab.TraderInfo;
    }
    else if (tab == ActiveTab.TraderPreference) {
      this.activeTab = ActiveTab.TraderPreference;
    }
    else if (tab == ActiveTab.ReviewAndSubmit) {
      this.activeTab = ActiveTab.ReviewAndSubmit;
    }
  }

  bindCity(event) {
    this.selectedState = this._validationService.getSelectedOptionText(event);
    this._commonService.getCitiesList(this.trade1031InputModel.state).subscribe(response => {
      this.citiesList = response.map(o => { return { Id: o.Id, Name: o.CityName }; });
    });
    this.trade1031InputModel.city = 0;
  }

  selectCity(event) {
    this.selectedCity = this._validationService.getSelectedOptionText(event);
  }

  //#region checkbox select all and deselect all
  selectAllAssetTypeValue = false;
  selectedPropertyType = '';
  assetsChecked(id: number, event: any) {

    let count = 0;
    this.selectedPropertyType = '';
    this.assetType.forEach(item => {
      if (item.selected == true) {
        count++;
        this.selectedPropertyType += item.description + ", ";
      }
    });

    if (count == this.assetType.length) {
      this.selectAllAssetTypeValue = true;
    }
    else {
      this.selectAllAssetTypeValue = false;
    }
    this.selectedPropertyType = this.selectedPropertyType.slice(0, -2);
  }
  assetsCheckAll(event: any) {
    this.selectedPropertyType = '';
    if (event.target.checked) {
      this.assetType.forEach(item => {
        item.selected = true;
        this.selectedPropertyType += item.description + ", ";
      });
    }
    else {
      this.assetType.forEach(item => {
        item.selected = false;
      });
    }
    this.selectedPropertyType = this.selectedPropertyType.slice(0, -2);
  }


  selectAllgeographyValue = false;
  selectedGeography = '';
  geographyChecked(id: number, event: any) {
    let count = 0;
    this.selectedGeography = '';
    this.geography.forEach(item => {
      if (item.selected == true) {
        count++;
        this.selectedGeography += item.description + ", ";
      }
    });
    if (count == this.geography.length) {
      this.selectAllgeographyValue = true;
    }
    else {
      this.selectAllgeographyValue = false;
    }
    this.selectedGeography = this.selectedGeography.slice(0, -2);
  }
  geographyCheckAll(event: any) {
    this.selectedGeography = '';
    if (event.target.checked) {
      this.geography.forEach(item => {
        item.selected = true;
        this.selectedGeography += item.description + ", ";
      });
    }
    else {
      this.geography.forEach(item => {
        item.selected = false;
      });
    }
    this.selectedGeography = this.selectedGeography.slice(0, -2);
  }
  //#endregion
  strategyText = '';
  strategyChange(id: number, name: any) {
    this.strategyText = name;
    this.trade1031InputModel.strategyid = id;
  }

  IsNull(val) {
    if (val == null || val == "0") {
      return '';
    }
    return val;
  }
  selectedExchangeLocation = '';
  exchangelocationChange(event) {
    if (event.target.value != 0) {
      this.selectedExchangeLocation = this._validationService.getSelectedOptionText(event);
    }
  }

  validateEntry(event, model) {
    if (event.target.value == ".") {
      event.target.value = "";
    }
  }

  openModal(template: TemplateRef<any>, classes: any) {
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  validateDecimals() {
    this.trade1031InputModel.capratemin = this._validationService.DecimalOnly(this.trade1031InputModel.capratemin);
    this.trade1031InputModel.capratemax = this._validationService.DecimalOnly(this.trade1031InputModel.capratemax);
    this.trade1031InputModel.rentmin = this._validationService.DecimalOnly(this.trade1031InputModel.rentmin);
    this.trade1031InputModel.rentmax = this._validationService.DecimalOnly(this.trade1031InputModel.rentmax);
  }
  currentGuid = "";
  showSuccessDiv = false;
  submit(template: TemplateRef<any>, classes: any) {
    this.istraderInfoSubmitted = true;
    this.showSuccessDiv = false;
    if (!this.traderInfoForm.invalid) {
      if (this.IsTradePreferenceValid()) {
        this.Loader.display(true);
        this.trade1031InputModel.sold_projectedsaledate = this._validationService.utcify(this.trade1031InputModel.sold_projectedsaledate);
        this.trade1031InputModel.propertytype = this.assetType;
        this.trade1031InputModel.geographytype = this.geography;
        this.trade1031InputModel.IPAddress = this.ipAddress;
        /*this.trade1031InputModel.loggedinUserId = this.user.Id;*/
        this.validateDecimals();

        this._Trade1031Service.Save1031Trade(this.trade1031InputModel).subscribe(res => {
          this.Loader.display(false);
          if (res["IsSuccess"] == true) {
            this.currentGuid = res["CurrentGuid"];
            if (this.isGuestUser || this.isNewEntry) {
              this.showSuccessDiv = true;
            }
            else {
              if (this.authService.Broker()) {
                this.redirect();
              }
              else {
                if (this.action === Actions.Update) {
                  this.redirect();
                }
                else {
                  const config = {
                    ignoreBackdropClick: true,
                    class: 'modal-position ' + classes,
                    keyboard: false,
                    backdrop: true
                  }
                  this.modalRef = this.modalService.show(template, config);
                }
              }
            }
            this._Trade1031Service.Save1031TradeToUserFlowLog(this.trade1031InputModel).subscribe(response => { });
            this._validationService.scrollTop();
          }
        });
      }
      else {
        this.Toast.addToast({ title: 'Error Occurred', msg: 'Please fill all the required field', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
        this.Loader.display(false);
      }
    }
    else {
      this.Toast.addToast({ title: 'Error Occurred', msg: 'Please fill all the required field', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      this.Loader.display(false);
    }
  }
  onContinue() {
    this._validationService.redirect('1031-trade');
  }
  redirect() {
    this.Toast.addToast({ title: 'Success', msg: '1031 Inquiry Updated Successfully.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
    if (this._validationService.IsinValid(this.BC_routeLink)) {
      this.router.navigate(['/1031-exchanges']);
    }
    else {
      if (this.BC_routeLink == '1031-trade') {
        this._validationService.redirect('1031-trade', 'pages/trade-1031');
      }
      else {
        this.router.navigateByUrl(this.BC_routeLink);
      }
    }
  }

  onCancel() {
    if (this.isNewEntry) {
      this._validationService.redirect('1031-trade');
    }
    else {
      if (this.action == Actions.Save) {
        //this.router.navigate(['/trade-1031']);
        if (this.authService.IsUserRole(this.authService.UserRole.Principal)) {
          this._validationService.redirect('1031-trade');
        }
        else if (this.authService.IsUserRole(this.authService.UserRole.Principal1031)) {
          this.router.navigateByUrl('/dashboard-1031/' + this.currentGuid + '?info=true');
        }

      }
      else {
        if (!this._validationService.IsinValid(this.BC_routeLink)) {
          if (this.BC_routeLink == '1031-trade') {
            this._validationService.redirect('1031-trade', 'pages/trade-1031');
          }
          else {
            this.router.navigateByUrl(this.BC_routeLink);
            return;
          }
        }

        if (this.authService.IsUserRole(this.authService.UserRole.Broker)) {
          this.router.navigate(['/1031-exchanges']);
        }
        else {
          this.router.navigateByUrl('/dashboard-1031/' + this.currentGuid);
        }
      }
    }
  }

  onBreadCrumbClick() {
    if (this.BC_routeLink == '1031-trade') {
      this._validationService.redirect('1031-trade', 'pages/trade-1031');
    }
    else {
      this.router.navigateByUrl(this.BC_routeLink);
    }
  }
}
